// Contracts/ModalManager.tsx
import React from 'react';
import PostInspectionAddendumModal from './PostInspectionAddendumModal';
import HomeownerReviewModal from './HomeownerReviewModal';
import PaymentReleaseModal from './PaymentReleaseModal';
import { ContractTemplateProps } from './Contract.interface';

interface ModalManagerProps {
  contract: ContractTemplateProps;
  isPostInspectionModalOpen: boolean;
  setIsPostInspectionModalOpen: (open: boolean) => void;
  isHomeownerReviewModalOpen: boolean;
  setIsHomeownerReviewModalOpen: (open: boolean) => void;
  isPaymentModalOpen: boolean;
  setIsPaymentModalOpen: (open: boolean) => void;
  selectedPaymentMilestone: {
    id: string;
    title: string;
    amount: number;
  } | null;
  setSelectedPaymentMilestone: (milestone: any) => void;
  onPaymentSuccess: () => void;
}

const ModalManager: React.FC<ModalManagerProps> = ({
  contract,
  isPostInspectionModalOpen,
  setIsPostInspectionModalOpen,
  isHomeownerReviewModalOpen,
  setIsHomeownerReviewModalOpen,
  isPaymentModalOpen,
  setIsPaymentModalOpen,
  selectedPaymentMilestone,
  setSelectedPaymentMilestone,
  onPaymentSuccess
}) => {
  return (
    <>
      <PostInspectionAddendumModal
        isOpen={isPostInspectionModalOpen}
        toggle={() => setIsPostInspectionModalOpen(false)}
        contractId={contract.id}
        contractPrice={typeof contract.contractPrice === 'string' ? parseFloat(contract.contractPrice) : contract.contractPrice}
        onComplete={() => setIsPostInspectionModalOpen(false)}
      />

      <HomeownerReviewModal
        isOpen={isHomeownerReviewModalOpen}
        toggle={() => setIsHomeownerReviewModalOpen(false)}
        contractId={contract.id}
        addendums={contract.addendums || []}
        onComplete={() => setIsHomeownerReviewModalOpen(false)}
      />

      <PaymentReleaseModal
        isOpen={isPaymentModalOpen}
        toggle={() => {
          setIsPaymentModalOpen(false);
          setSelectedPaymentMilestone(null);
        }}
        milestoneId={selectedPaymentMilestone?.id || ''}
        milestoneTitle={selectedPaymentMilestone?.title || ''}
        paymentAmount={selectedPaymentMilestone?.amount || 0}
        contractId={contract.id}
        onPaymentSuccess={onPaymentSuccess}
      />
    </>
  );
};

export default ModalManager;